// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef5f8f66","455":"fbdf9eb8","977":"8a0b8320"}[chunkId] + ".chunk.js";
};